<template>
  <div>
    <div class="enterprise-info">
      {{currentDepartment.departmentName}}
      <span
        style="color: #19be6b;font-size: 18px;margin-left: 10px;"
      >{{departmentEmployeesCount.employeeCount}}人</span>
      <span
        style="color: #666666;font-size: 18px;margin-left: 10px;"
      >(未激活{{departmentEmployeesCount.unactivatedEmployeeCount}}人)</span>
    </div>

    <Divider />

    <div class="add-emloyee-action">
      <Input
        search
        placeholder="输入员工姓名"
        v-model="searchVal"
        @on-search="searchEmployees"
        size="large"
      />

      <div class="add-action">
        <el-button
          type="primary"
          @click="$refs.employeeAction.modifyEmployee({isAdd:true})"
          size="medium"
        >添加人员</el-button>
        <employee-invite />
      </div>
    </div>

    <Table border :columns="tableType" :data="tableData">
      <template slot-scope="{ row, index}" slot="action">
        <Button
          v-for="(item, index) in getEmployeeActions(row.channel, row.enumCode)"
          :key="index"
          @click="handleClickEmployee(row, item.functionName)"
        >{{item.actionName}}</Button>

        <!-- <a class="aLink" @click.stop="editAgreeMethodTransfer(row)">{{ row | editAgreeStatusTip }}</a>
        <a class="aLink" @click.stop="otherStatusMethodTransfer(row)">{{ row | otherStatusShow }}</a>-->
      </template>
    </Table>

    <!-- page -->
    <Page
      :total="total"
      :current="pagePagination.from"
      :page-size="pagePagination.size"
      @on-change="setPaginationFrom"
      @on-page-size-change="setPaginationSize"
      show-elevator
      show-sizer
      class="pagination"
    />

    <employee-action ref="employeeAction" />
  </div>
</template>



<script>
import { MessageBox } from "element-ui";

import EmployeeAction from "./EmployeeAction";
import EmployeeInvite from "./Invite";
import OrganizeStatus from "./OrganizeStatus";

import pagination from "@/view/mixins/pagination";

import { employeesActionConfig } from "../constant";

export default {
  components: {
    EmployeeAction,
    EmployeeInvite,
    OrganizeStatus
  },

  mixins: [pagination],

  created() {
    this.$observer.$on("changeDepartment", department => {
      this.currentDepartment = department;
    });
  },

  computed: {
    searchParameter() {
      let searchParameter = {
        id: this.currentDepartment.id,
        conditions: []
      };

      if (this.searchVal)
        searchParameter.conditions.push({
          field: "name",
          value: this.searchVal,
          operation: "like",
          type: "and"
        });

      Object.assign(searchParameter, this.$js.deepClone(this.pagePagination));

      return searchParameter;
    },
    tableType() {
      return [
        {
          title: "工号",
          key: "employeeNumber",
          align: "center",
          minWidth: 100
        },
        {
          title: "员工姓名",
          key: "employeeName",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            return h(OrganizeStatus, {
              props: {
                statusCode: params.row.enumCode,
                name: params.row.employeeName,
                isDepartmentManager: params.row.isDepartmentManager,
                channel: params.row.channel
              },
              style: {
                height: "100%",
                width: "100%",
                cursor: "pointer"
              }
            });
          }
        },
        {
          title: "部门",
          key: "organizationName",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  fontWeight: "900",
                  color: "#464c5b",
                  fontFamily: "Helvetica Neue"
                }
              },
              this.$js.concatStr("departmentName", params.row.departments)
            );
          }
        },
        {
          title: "职位",
          key: "post",
          align: "center",
          minWidth: 100
        },
        {
          title: "手机号",
          key: "employeePhoneNum",
          align: "center",
          minWidth: 200
        },
        {
          title: "角色",
          key: "roles",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  fontWeight: "900",
                  color: "#464c5b",
                  fontFamily: "Helvetica Neue"
                }
              },
              this.$js.concatStr("roleName", params.row.roles)
            );
          }
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  watch: {
    "currentDepartment.id": {
      handler(id) {
        this.searchVal = "";
        this.getNoLeaveCount(id);
        this.resetDepartmentEmployees();
      }
    },

    //重新获取数据
    refData(val) {
      this.getEmployee();
    }
  },
  data() {
    return {
      currentDepartment: {
        departmentName: "",
        id: "all"
      },

      departmentEmployeesCount: {
        employeeCount: 0,
        unactivatedEmployeeCount: 0
      },

      searchVal: "",

      tableData: [],

      setTableData: this.setDepartmentEmployees,

      employeeEnumList: [],

      defaultVal: [],

      //修改,增加,删除,离职人员刷新数据
      refData: false,
      enumItem: [],
      invitation: false
    };
  },

  methods: {
    getEmployeeActions(channel, enumCode) {
      return employeesActionConfig.filter(config => {
        return config.condition(channel, enumCode);
      });
    },

    handleClickEmployee(row, functionName) {
      if (functionName === "modifyEmployee") {
        this.$refs.employeeAction[functionName]({ isAdd: false, data: row });
      } else {
        this.$refs.employeeAction[functionName](row);
      }
    },

    getNoLeaveCount(departmentId) {
      this.$api.getNoLeaveCount(departmentId).then(count => {
        this.departmentEmployeesCount = count;
      });
    },

    async setDepartmentEmployees() {
      let { records, total } = await this.$api.getEmployeeByDepartmentAll(
        this.searchParameter
      );

      if (!this.employeeEnumList.lenght) {
        const res = await this.$api.getEnumItemByCode("employee");

        this.employeeEnumList = res[0].enumItems;
      }

      this.total = total;
      this.tableData = records;

      this.tableData.forEach(item => {
        item.enumCode = this.$js.getEnumCode(
          item.statusEnumItemId,
          this.employeeEnumList
        );
      });
    },

    searchEmployees(value) {
      this.resetDepartmentEmployees();
    },

    resetDepartmentEmployees() {
      if (this.resetPaginationFrom()) return;
      this.setDepartmentEmployees();
    }
  }
};
</script>

<style scoped lang="scss">
.add-emloyee-action {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  ::v-deep .ivu-input-wrapper {
    width: 250px;
  }

  .add-action {
    width: 210px;
    display: flex;
    justify-content: space-between;
  }
}

.enterprise-info {
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0 0 5px;
}

.pagination {
  float: right;
  margin-top: 30px;
}
</style>
